// extracted by mini-css-extract-plugin
export default {"button":"EditModal_button__1fGHF","divider":"EditModal_divider__vgy4w","link":"EditModal_link__nB0Aw"};